import { Injectable } from '@angular/core';

import { ApiService } from './api.service';

export interface JsmInstance {
  id: string;
  name: string;
  url: string;
}

export interface JsmCredential {
  id: string;
  jsmInstanceId: string;
  scopes: Record<string, boolean>;
  createdAt: string;
  updatedAt: string;
  jsmInstance: JsmInstance | null;
}

export interface JsmServiceDesk {
  id: string;
  projectId: string;
  projectName: string;
  projectKey: string;
  projectTypeKey: string;
}

export interface JsmServiceDesksResponse {
  start: number;
  limit: number;
  size: number;
  isLastPage: boolean;
  values: JsmServiceDesk[];
}

@Injectable({
  providedIn: 'root',
})
export class JsmService {
  constructor(private apiService: ApiService) {}

  async getConnectedCredentials(): Promise<JsmCredential[]> {
    return await this.apiService.getPromise<JsmCredential[]>('/jsm/credentials');
  }

  async getServiceDesks(jsmInstanceId: string, start?: number, limit: number = 50): Promise<JsmServiceDesksResponse> {
    const params = new URLSearchParams();

    if (start !== undefined) {
      params.append('start', start.toString());
    }

    params.append('limit', limit.toString());

    return await this.apiService.getPromise<JsmServiceDesksResponse>(
      `/jsm/instances/${jsmInstanceId}/service-desks?${params.toString()}`,
    );
  }

  async getAllServiceDesks(jsmInstanceId: string): Promise<JsmServiceDesk[]> {
    const allServiceDesks: JsmServiceDesk[] = [];
    let start = 0;
    let isLastPage = false;

    while (!isLastPage) {
      const response = await this.getServiceDesks(jsmInstanceId, start);

      allServiceDesks.push(...response.values);

      start += response.size;
      isLastPage = response.isLastPage;
    }

    return allServiceDesks;
  }

  async bulkCreateChannels(
    projectId: string,
    credentialId: string,
    jsmInstanceId: string,
    serviceDesks: { id: string; name: string }[],
  ): Promise<{
    success: boolean;
    created: number;
    failed: number;
    results: any[];
    errors: any[];
  }> {
    return await this.apiService.postPromise('/jsm/channels/bulk', {
      projectId,
      credentialId,
      jsmInstanceId,
      serviceDesks,
    });
  }
}
